"use client";

import Image from "next/image";

type Props = {
  title: string;
};

export function ShareButton({ title }: Props) {
  const handleShare = async () => {
    if (typeof window === "undefined" || typeof navigator === "undefined" || typeof navigator.share !== "function") {
      return;
    }

    try {
      const url = window.location.href;
      await navigator.share({
        title,
        text: title,
        url
      });
    } catch {
      // User cancelled or share failed — silent
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      aria-label="Share this piece"
      className="md:hidden inline-flex shrink-0 items-center justify-center rounded-sm text-slate-600 transition hover:text-slate-900"
      style={{ width: 36, height: 36, minWidth: 36, minHeight: 36 }}
    >
      <Image src="/share.svg" alt="" width={24} height={24} className="shrink-0" aria-hidden="true" />
    </button>
  );
}
